import { Worker } from './remote-worker';

const avaiableWorkers = {
  'liquid-renderer': {
    worker: null,
    module: null,
    sessions: new Map(),
    config: {
      createInstance: () =>
        new Worker(
          /* webpackPrefetch: true */
          /* webpackChunkName: "liquid-renderer.worker" */
          new URL('./liquid-renderer.worker.js', import.meta.url)
        ),
      loadModule: async () => {
        const module = await import('./liquid-renderer.worker.js');
        avaiableWorkers['liquid-renderer'].module = module;
      },
    },
  },
  analytics: {
    worker: null,
    sessions: new Map(),
    config: {
      createInstance: () =>
        new Worker(
          /* webpackPrefetch: true */
          /* webpackChunkName: "analytics.worker" */
          new URL('./analytics.worker.js', import.meta.url)
        ),
    },
  },
};

function createSessionInfo() {
  return {
    id: Math.random().toString(36).substring(2),
    resolve: null,
    reject: null,
    timeout: null,
  };
}

function isSafari() {
  return navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}

function shouldUseModule() {
  return isSafari() || window.boostWidgetIntegrationConfig?.workers?.useModule === true;
}

function setupWorker(workerName) {
  const worker = avaiableWorkers[workerName].config.createInstance();
  avaiableWorkers[workerName].worker = worker;

  worker.onmessage = function (event) {
    const {
      data: { sessionId, response },
    } = event;

    const sessions = avaiableWorkers[workerName].sessions;

    const sessionInfo = sessions.get(sessionId);

    if (sessionInfo) {
      sessionInfo.resolve(response);

      clearTimeout(sessionInfo.timeout);
      sessions.delete(sessionId);
    }
  };

  if (shouldUseModule()) {
    avaiableWorkers[workerName].config.loadModule?.();
  }
}

export function warmupWorkers() {
  for (const workerName in avaiableWorkers) {
    if (Object.prototype.hasOwnProperty.call(avaiableWorkers, workerName)) {
      if (!avaiableWorkers[workerName].worker) {
        setupWorker(workerName);
      }
    }
  }
}

export function startSession(workerName) {
  const workerModule = avaiableWorkers[workerName];

  const { worker, sessions } = workerModule;

  if (!worker) {
    setupWorker(workerName);
  }

  const sessionInfo = createSessionInfo();

  return {
    async send(payload) {
      const event = {
        sessionId: sessionInfo.id,
        payload,
      };

      if (shouldUseModule() && workerModule.config.loadModule) {
        if (!workerModule.module) {
          await workerModule.config.loadModule();
        }
        const { module } = workerModule;
        const { response } = await module.default({
          data: event,
        });

        return response;
      }

      return new Promise((resolve, reject) => {
        sessionInfo.resolve = resolve;
        sessionInfo.reject = reject;

        sessions.set(sessionInfo.id, sessionInfo);

        worker.postMessage(event);

        const timeout = setTimeout(() => {
          const session = sessions.get(sessionInfo.id);
          if (session) {
            session.reject(new Error('Worker timeout'));
            sessions.delete(sessionInfo.id);
          }
        }, 10000);

        sessionInfo.timeout = timeout;
      });
    },
  };
}
